import { ref } from 'vue'

const touchCount = ref(0)

const updateTouchCount = (event: Event) => {
  if (!(event instanceof TouchEvent)) return

  touchCount.value = event.touches.length
}

document.addEventListener('touchstart', updateTouchCount)
document.addEventListener('touchend', updateTouchCount)

export function useTouchCount() {
  return touchCount
}
